import { toast } from "react-toastify"

import { api } from "~/utils/api"
import { showErrorToast } from "~/utils/toaster"
import { mergeMap } from "~/utils/tsUtils"
import { useRefreshForecastDomain } from "~/utils/cacheUtils/forecastCacheHelpers"
import { usePartialRefreshStockOutTimes } from "~/utils/cacheUtils/stockOutTimesCacheHelpers"
import { usePartialRefreshVariants } from "~/utils/cacheUtils/variantCacheHelpers"

export const useMutateDeactivateSkus = (callback?: Function) => {
  const utils = api.useUtils()
  const refreshVariants = usePartialRefreshVariants()
  const refreshStockOutTimes = usePartialRefreshStockOutTimes()

  return api.npi.deactivateSkus.useMutation({
    onSuccess: async (_data, variables) => {
      // No need to invalidate other endpoints, as the deactivated SKUs will not be shown in the UI
      await utils.npi.variants.invalidate()
      utils.productManagement.categorizeVariants.invalidate()
      await Promise.all([
        refreshVariants(variables.variantIds),
        refreshStockOutTimes(variables.variantIds),
      ])

      if (callback) {
        callback()
      }

      toast.success("Variants deactivated successfully")
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export const useMutateActivateSkus = (callback?: Function) => {
  const utils = api.useUtils()

  const refreshForecastDomain = useRefreshForecastDomain()
  const refreshStockOutTimes = usePartialRefreshStockOutTimes()

  return api.npi.activateSkus.useMutation({
    onSuccess: async (data, variables) => {
      await utils.npi.variants.invalidate()
      utils.productManagement.categorizeVariants.invalidate()
      utils.variantTableData.settings.setData(undefined, (oldData) =>
        mergeMap(oldData, data.settings),
      )
      void utils.npi.getCombinedSeasonalityForVariants.invalidate()
      void utils.npi.getSeasonalityDetailsForVariant.invalidate()

      await Promise.all([
        refreshForecastDomain(variables.variantIds),
        refreshStockOutTimes(variables.variantIds),
      ])

      if (callback) {
        callback()
      }

      toast.success("Variants activated successfully")
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}
